import { StyledSupportMenuAura, StyledSupportMenuIcon } from '@/modules/support/components/SupportMenu/styles';
import { IconButton } from '@mui/material';

const DEFAULT_SIZE = 32;

type SupportButtonProps = {
  isAura?: boolean;
  size?: number;
};

export const SupportButton = (props: SupportButtonProps) => {
  const { isAura, size = DEFAULT_SIZE } = props;
  return (
    <StyledSupportMenuAura width={size} isAura={isAura}>
      <IconButton>
        <StyledSupportMenuIcon width={size} />
      </IconButton>
    </StyledSupportMenuAura>
  );
};
